"use client";
import React from "react";
// import GlobalHeader from "@/components/common/newCommonComponent/GlobalHeader";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircle,
  faAnglesRight,
  faArrowRight,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

const MobilePage: React.FC = () => {
  return (
    <>
      <div className="w-full bg-white">
        <GlobalHeaderNew />
        <div className="mx-auto w-full square_grid_bg">
          <div className="lg:container mx-auto 2xl:px-0 10 md:px-5 lg:px-5">
            <div className="mx-auto lg:p-0 min-h-screen">
              <div className="term-sec relative lg:top-[40px] top-7 z-20 lg:text-left md:text-left mb-[50px]">
                <h1 className="text-[20px] md:mb-3 mb-0 font-semibold lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-[#0C1F33] text-center">
                  <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2">
                    Privacy policy
                  </span>
                </h1>
                <ul className="pt-[10px] mb-[65px] lg:px-0 px-[15px]">
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Purpose
                        </p>
                        <p>
                          Miles Education (“Miles Education”, “we”, or “us”) is
                          committed to protecting your privacy; we take data
                          protection and privacy very seriously. This Privacy
                          Policy (“Policy”) describes how Miles Education
                          collects, uses, shares and secures the personal
                          information you provide when you visit the Websites
                          and Mobile Apps owned and operated by Miles Education
                          (listed below), and when you use our Service(s). It
                          also describes your choices regarding use, access, and
                          correction of your personal information. The use of
                          information collected through our Service(s) shall be
                          limited to the purpose of providing the service for
                          which you have engaged in Miles Education. The
                          capitalized terms used in this Policy but not defined
                          herein shall have the same meaning as defined in our
                          Terms of Service at (“Terms”).
                        </p>
                        <p>Miles Education Website and Mobile Apps</p>
                        <ul className="pl-[15px] pt-[10px]">
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                Website:{" "}
                                <a className="text-[#5b6efd]" href="/">
                                  {" "}
                                  MilesEducation.com
                                </a>
                              </p>
                            </div>
                          </li>
                          <li className="pb-[12px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>Mobile Apps: iOS, Android</p>
                            </div>
                          </li>
                        </ul>
                        <p>
                          Please read this Privacy Policy carefully, as it
                          governs how you use Miles Education or its affiliate
                          products. If you do not agree to this Privacy Policy,
                          please do not use Miles Education.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Notice to End User
                        </p>
                        <ul className="pl-[15px]">
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                In some cases, an administrator may create an
                                account in Miles Education on behalf of an
                                “End-User” and may provide his/her information,
                                including Personal Information. In such cases,
                                the administrator who may be your Employer or a
                                Miles Education Authorized Training Partner
                                (ATP) is our “Customer.” We collect Information
                                under the direction of our customers and have no
                                direct relationship with the End-User whose
                                personal data we process.
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                An End-user’s use of the Miles Education
                                platform may be subject to the Customer’s
                                policies if any.
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                Our Customers must have the authority to act on
                                behalf of the End-User and to consent to the
                                collection and use of their Personal Information
                                as described in this Privacy Policy.
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                If you are an End-user using our platform,
                                please direct your privacy inquiries to your
                                administrator. Miles Education is not
                                responsible for the privacy or security
                                practices of our customers, which may differ
                                from those set forth in this privacy statement.
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                Miles Education may send personalized
                                advertisements or marketing communications to
                                end-users through email, SMS, WhatsApp,
                                automated phone calls, and social media
                                platforms.
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          International Transfer
                        </p>
                        <ul className="pl-[15px]">
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                Personal data collected by Miles Education may
                                be stored and processed in your region, and in
                                any other country where Miles Education or its
                                affiliates, data sub-processors operate
                                facilities. To facilitate Miles Education global
                                operations, we may transfer and access such
                                information from around the world, including
                                from other countries in which the Company has
                                operations. A list of the Miles Education’s
                                global offices is available here. This Privacy
                                Statement shall apply even if Miles Education
                                transfers Data to other countries
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                Currently, Miles Education and its data
                                sub-processors have data centers in India.
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                The data we hold may also be processed by
                                employees operating in countries listed above,
                                such staff maybe engaged in, among other things,
                                product development and customer and technical
                                support. The data protection and other laws of
                                these countries might not be as comprehensive as
                                those in your country. By submitting your data
                                and/or using Our Services, You consent to the
                                transfer, storing, and processing of your data
                                in these countries.
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                <b>
                                  Use of your Personal Information and Other
                                  Data:
                                </b>
                                <br></br>
                                Miles Education uses this Privacy Policy to
                                govern the use of personal information you
                                provide to us. We use your personal information
                                solely to provide our services to you. We also
                                use your Personal Identifiable Information (PII)
                                together with other Personally Non-Identifiable
                                Information (non - PII)to help us better
                                understand our users and to improve the content
                                and functionality of our site.
                              </p>
                            </div>
                            <ul className="pt-[8px] pl-[35px]">
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>
                                    When you visit our website or mobile apps
                                    and voluntarily provide the following
                                    information via one of our contact forms,
                                    via a chat or phone session, or as part of a
                                    purchase of one of our courses or register
                                    on our site:
                                  </p>
                                </div>
                                <ul className="pt-[8px] pl-[35px]">
                                  <li className="pb-[8px]">
                                    <div className="inline-flex">
                                      <FontAwesomeIcon
                                        className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                        icon={faMinus}
                                      />
                                      <p>
                                        Contact Information, such as name, email
                                        address, mailing address, phone number,
                                        IP
                                      </p>
                                    </div>
                                  </li>
                                  <li className="pb-[8px]">
                                    <div className="inline-flex">
                                      <FontAwesomeIcon
                                        className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                        icon={faMinus}
                                      />
                                      <p>
                                        Information about your business, such as
                                        company name, company size, business
                                        type
                                      </p>
                                    </div>
                                  </li>
                                  <li className="pb-[8px]">
                                    <div className="inline-flex">
                                      <FontAwesomeIcon
                                        className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                        icon={faMinus}
                                      />
                                      <p>
                                        Billing Information, such as credit card
                                        number and billing address
                                      </p>
                                    </div>
                                  </li>
                                  <li className="pb-[8px]">
                                    <div className="inline-flex">
                                      <FontAwesomeIcon
                                        className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                        icon={faMinus}
                                      />
                                      <p>
                                        <b>Note:</b> All payment transactions
                                        are processed through secure payment
                                        gateway providers. We do not store any
                                        card information (other than the last 4
                                        digits of your card) on our servers.
                                        When you use our Learning Management
                                        System, mobile applications, our support
                                        system or respond to our surveys:
                                      </p>
                                    </div>
                                  </li>
                                  <li className="pb-[8px]">
                                    <div className="inline-flex">
                                      <FontAwesomeIcon
                                        className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                        icon={faMinus}
                                      />
                                      <p>
                                        Contact Information, such as name, email
                                        address, mailing address, IP address,
                                        geographic location, or phone number
                                      </p>
                                    </div>
                                  </li>
                                  <li className="pb-[8px]">
                                    <div className="inline-flex">
                                      <FontAwesomeIcon
                                        className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                        icon={faMinus}
                                      />
                                      <p>
                                        Unique Identifiers, such as username, or
                                        password
                                      </p>
                                    </div>
                                  </li>
                                  <li className="pb-[8px]">
                                    <div className="inline-flex">
                                      <FontAwesomeIcon
                                        className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                        icon={faMinus}
                                      />
                                      <p>
                                        Name and e-mail address when you provide
                                        feedback from the Service(s)
                                      </p>
                                    </div>
                                  </li>
                                  <li className="pb-[8px]">
                                    <div className="inline-flex">
                                      <FontAwesomeIcon
                                        className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                        icon={faMinus}
                                      />
                                      <p>
                                        When you use our community website or
                                        blogs
                                      </p>
                                    </div>
                                  </li>
                                  <li className="pb-[8px]">
                                    <div className="inline-flex">
                                      <FontAwesomeIcon
                                        className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                        icon={faMinus}
                                      />
                                      <p>
                                        Please refer to our section on Public
                                        Forums
                                      </p>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>
                                    Users may, however, visit our Site
                                    anonymously. We will collect personal
                                    identification information from Users only
                                    if they voluntarily submit such information
                                    to us. Users can always refuse to supply
                                    personally identification information,
                                    except that it may prevent them from
                                    engaging in certain Site related activities.
                                  </p>
                                </div>
                              </li>
                            </ul>
                          </li>

                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                <b>Non-Personal Identifiable Data:</b>
                                <br></br>
                                We capture some Non Identifiable data in our
                                logs. The data in the logs includes
                              </p>
                            </div>
                            <ul className="pt-[8px] pl-[35px]">
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Device type</p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Browser type</p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Language preference</p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Time zone</p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Screen size</p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Referring / exit pages</p>
                                </div>
                              </li>
                            </ul>
                          </li>

                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                <b>Use of information</b>
                                <br></br>
                                We may use the personal information collected
                                from within the Websites or when you use the
                                Service(s) to:
                              </p>
                            </div>
                            <ul className="pt-[8px] pl-[35px]">
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Provide you with the Service(s).</p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>
                                    Send you communication from the Service(s)
                                  </p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>
                                    Assess the needs of your business to
                                    determine or suggest suitable products.
                                  </p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>
                                    Send you requested product or service
                                    information.
                                  </p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Respond to customer service requests.</p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Administer your account.</p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>
                                    Send you promotional and marketing
                                    communications.
                                  </p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>Personalized Advertisement</p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>
                                    Facilitate your transactions with other
                                    users when you use our Service(s).
                                  </p>
                                </div>
                              </li>
                              <li className="pb-[8px]">
                                <div className="inline-flex">
                                  <FontAwesomeIcon
                                    className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                    icon={faArrowRight}
                                  />
                                  <p>
                                    Perform statistical analyses of user
                                    behavior and characteristics at an aggregate
                                    level in order to measure interest in and
                                    use of the various areas of the site.
                                  </p>
                                </div>
                              </li>
                            </ul>
                          </li>

                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faAnglesRight}
                              />
                              <p>
                                When you provide us with personal information
                                about your contacts we will only use this
                                information for the specific reason for which it
                                is provided.
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Share
                        </p>
                        <p>
                          If your subscription was provided by your employer or
                          a Miles Education authorized training partner, we will
                          share information, including personal information with
                          them.
                        </p>
                        <p>
                          We may also disclose your personal information to any
                          other third party with your prior consent. However,
                          the data will not be shared for SMS purposes with the
                          third party.{" "}
                        </p>
                        <p>
                          We may transfer personal information to our Group
                          Companies and subcontractors that help us provide our
                          Service(s). Transfers to subsequent third parties are
                          covered by the service agreements with our data
                          processors. We reserve the right to disclose your
                          personal data as required by applicable law, in
                          response to lawful requests by public authorities,
                          including meeting national security or law enforcement
                          requirements and when we believe that disclosure is
                          necessary to protect our rights and/or to comply with
                          a judicial proceeding, court order, or other legal
                          process served on us.
                        </p>
                        <p>
                          In the event Miles Education goes through a business
                          transition, such as a merger or acquisition by another
                          company, or sale of all or a portion of its assets,
                          your user account, and personal data will likely be
                          among the assets transferred. You will be notified via
                          email and via prominent notice on our Websites of any
                          such change in ownership or control. We may also
                          disclose your personal information to any other third
                          party with your prior consent.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Data from Third Parties
                        </p>
                        <p>
                          We also obtain data from third parties. We protect
                          data obtained from third parties according to the
                          practices described in this statement, plus any
                          additional restrictions imposed by the source of the
                          data. These third-party sources vary over time, but
                          have included:
                        </p>
                      </div>
                    </div>
                    <ul className="pt-[10px] pl-[35px]">
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <p>
                            Data brokers from which we purchase demographic data
                            to supplement the data we collect.
                          </p>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <p>
                            Social networks when you grant permission to access
                            your data on one or more networks.
                          </p>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <p>
                            Existing or past learners who participate in our
                            referral program
                          </p>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <p>
                            Service providers that help us determine a location
                            based on your IP address in order to customize
                            certain products to your location.
                          </p>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <p>
                            Partners with which we offer co-branded services or
                            engage in joint marketing activities.
                          </p>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <p>
                            Publicly-available sources such as open government
                            databases or other data in the public domain.
                          </p>
                        </div>
                      </li>
                    </ul>
                    <p className="pl-[25px]">
                      We may receive Personal Information about you from other
                      sources like postal mail, telephone or fax. We may add
                      this information to the information we have already
                      collected from you via the Site in order to improve the
                      products and services we provide.
                    </p>
                    <ul className="pt-[10px] pl-[35px]">
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <div>
                            <p className="pb-[5px]">
                              <b className="mb-[20px]">
                                Correction, Removal or Export of Personal
                                Information:
                              </b>
                            </p>
                            <p>
                              Miles Education acknowledges that you have the
                              right to access, edit and delete your personal
                              information at any time. Upon request, we will
                              provide you with reasonable access to the personal
                              information we collect about you. You will have
                              the opportunity to correct, update, modify or
                              delete this information as follows:
                            </p>
                          </div>
                        </div>
                        <ul className="pt-[8px] pl-[35px]">
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faArrowRight}
                              />
                              <p>
                                If you have independently signed up with Miles
                                Education. You may access, update or export your
                                Personal Information included in your online
                                Miles Education account at any time by logging
                                into your account and going to your profile or
                                by reaching out to us
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faArrowRight}
                              />
                              <p>
                                If you are using an enterprise-provided account
                                (Miles Education Authorised Training Partner or
                                your Employer). Please review the section Notice
                                to End Users
                              </p>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <div>
                            <p className="pb-[5px]">
                              <b className="mb-[20px]">
                                Exceptions in Deletion:
                              </b>
                            </p>
                            <p>
                              If you request access to your personal information
                              and discover that that information is wrong, we
                              strive to give you ways to update it quickly or to
                              delete it – unless we have to keep that
                              information for legitimate business or legal
                              purposes. We aim to maintain our services in a
                              manner that protects information from accidental
                              or malicious destruction. Because of this, after
                              you delete information from our services, we may
                              not immediately delete residual copies from our
                              active servers or backup systems.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <div>
                            <p className="pb-[5px]">
                              <b className="mb-[20px]">
                                Exception in Data Portability:
                              </b>
                            </p>
                            <p>
                              There may be limits to the amount of information
                              we can practically provide. For example, we may
                              limit an individual’s access to personal
                              information where the burden or expense of
                              providing access would be disproportionate to the
                              risks to the individual’s privacy or where doing
                              so would violate others’ rights
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <div>
                            <p className="pb-[5px]">
                              <b className="mb-[20px]">
                                Exception in Data Correction:
                              </b>
                            </p>
                            <p>
                              Even after updates to your Personal Information,
                              we may maintain and store older versions of such
                              information within our databases, access logs, and
                              other records in order to comply with other
                              routine data audits.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <div>
                            <p className="pb-[5px]">
                              <b className="mb-[20px]">
                                Cookies and Other Tracking Technologies:
                              </b>
                            </p>
                            <p>
                              Miles Education and our third-party partners, such
                              as our advertising and analytics partners, (listed
                              here) use cookies and other tracking technologies
                              (e.g., web beacons, device identifiers and pixels)
                              to provide functionality and to recognize you
                              across different Services and devices. The types
                              of cookies used by Miles Education includes
                            </p>
                          </div>
                        </div>
                        <ul className="pt-[8px] pl-[35px]">
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faArrowRight}
                              />
                              <p>
                                <b>Essential Cookies:</b> These cookies are
                                essential for the basic functionalities offered
                                by the Site and Service(s). These class of
                                cookies helps in keeping a user logged in to the
                                Service(s) and remember relevant information
                                when they return to the Service(s).
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faArrowRight}
                              />
                              <p>
                                <b>Insight Cookies:</b> These are used for
                                tracking the user activities within the
                                Service(s), which in turn helps us in improving
                                your user experience.
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faArrowRight}
                              />
                              <p>
                                <b>Marketing Cookies:</b> These are used for
                                providing you with customized and interest-based
                                ads based on your browsing behavior and other
                                similar activities on our Websites.
                              </p>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                    <p className="pl-[56px]">
                      You can choose to have your computer warn you each time a
                      cookie is being sent, or you can choose to turn off all
                      cookies. You do this through your browser settings. Since
                      each browser is different, look at your browser's Help
                      Menu to learn the correct way to modify your cookies. If
                      you turn cookies off, some of the features that make your
                      site experience more efficient may not function properly.
                    </p>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Data from Third Parties
                        </p>
                        <p>
                          Currently, various browsers — including Internet
                          Explorer, Firefox, and Safari — offer a “do not track”
                          or “DNT” option that relies on a technology known as a
                          DNT header, which sends a signal to Web sites’ visited
                          by the user about the user's browser DNT preference
                          setting. Miles Education does not currently commit to
                          responding to browsers' DNT signals with respect to
                          the Company's Web sites, in part, because no common
                          industry standard for DNT has been adopted by industry
                          groups, technology companies or regulators, including
                          no consistent standard of interpreting user intent.
                          Miles Education takes privacy and meaningful choice
                          seriously and will make efforts to continue to monitor
                          developments around DNT browser technology and the
                          implementation of a standard.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Advertisement
                        </p>
                        <p>
                          We partner with third parties to manage our
                          advertising on other sites. Our third-party partners
                          may use technologies such as cookies to gather
                          information about your activities on our Website and
                          other sites in order to provide you advertising based
                          upon your browsing activities and interests. Please
                          note this does not opt you out of being served ads.
                          You will continue to receive generic ads.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Analytics & Web-beacons
                        </p>
                        <p>
                          Miles Education uses third party software for
                          analytics. All metrics information collected from your
                          usage of the Service(s) shall be transmitted to our
                          analytics provider. This information is then used to
                          evaluate how users use our platform, and to compile
                          statistical reports on user activity for us. We
                          further use the same statistical analytics tool to
                          track or to collect your Personally Identifiable
                          Information (PII). We will use this information in
                          order to maintain, enhance, or add to the
                          functionality of the Service(s) and to personalize the
                          experience for you. Aggregated information and
                          analysis may be made public where desired by Miles
                          Education.
                        </p>
                        <p>
                          We and our third-party advertising partners use
                          technologies such as web beacons in analyzing trends,
                          administering the website, tracking users’ movements
                          around the site, and gather demographic information
                          about our user base as a whole. We may receive reports
                          based on the use of these technologies by these
                          companies on an individual and aggregated basis.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Do Not Track
                        </p>
                        <p>
                          Currently, various browsers — including Internet
                          Explorer, Firefox, and Safari — offer a “do not track”
                          or “DNT” option that relies on a technology known as a
                          DNT header, which sends a signal to Web sites’ visited
                          by the user about the user's browser DNT preference
                          setting. Miles Education does not currently commit to
                          responding to browsers' DNT signals with respect to
                          the Company's Web sites, in part, because no common
                          industry standard for DNT has been adopted by industry
                          groups, technology companies or regulators, including
                          no consistent standard of interpreting user intent.
                          Miles Education takes privacy and meaningful choice
                          seriously and will make efforts to continue to monitor
                          developments around DNT browser technology and the
                          implementation of a standard.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Links to Third Party Sites
                        </p>
                        <p>
                          Our Websites contain links to other websites that are
                          not owned or controlled by Miles Education. Please be
                          aware that we are not responsible for the privacy
                          practices of such other websites or third parties. We
                          encourage you to be aware when you leave our Websites
                          and to read the privacy policies of each and every
                          website that collects personal information.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Public Forums
                        </p>
                        <p>
                          Our Websites offer publicly accessible blogs or
                          community forums. You should be aware that any
                          information you provide in these areas may be read,
                          collected, and used by others who access them. To
                          request removal of your personal information from our
                          blog or community forum,{" "}
                          <a className="text-[#5b6efd]" href="/">
                            {" "}
                            reach out to us.
                          </a>{" "}
                          In some cases, we may not be able to remove your
                          personal information, in which case we will let you
                          know that we are unable to do so and why. Miles
                          Education may provide bulletin boards, blogs, or
                          community threads on the Company’s Web sites. Any
                          personal information you choose to submit in such a
                          forum may be read, collected, or used by others who
                          visit these forums and may be used to send you
                          unsolicited messages. Miles Education is not
                          responsible for the personal information you choose to
                          submit in these forums.
                        </p>
                        <p>
                          Remember that when you share information publicly, it
                          may be indexable by search engines.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Single Sign-On & Other Social Media Features
                        </p>
                        <p>
                          Our Websites include social media features, such as
                          the Facebook “Like” button, the “Share This” button or
                          interactive mini-programs. Where we have your consent,
                          these features may collect your IP address, which page
                          you are visiting on our Websites, and may set a cookie
                          to enable the feature to function properly. Social
                          media features and widgets are either hosted by a
                          third party or hosted directly on our Websites. Your
                          interactions with these features are governed by the
                          privacy policy of the company providing them.
                        </p>
                        <p>
                          You can log in to our Websites using sign-in services
                          by LinkedIn. The services will authenticate your
                          identity and provide you the option to share certain
                          personal information with us such as your name and
                          email address.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Communications from the Websites
                        </p>
                        <p>
                          We may use your email address to send our newsletters
                          and/or marketing communications. If you no longer wish
                          to receive these communications, you can opt-out by
                          following the instructions contained in the emails.
                        </p>
                        <p>
                          We will send you announcements related to the
                          Service(s) on occasions when it is necessary to do so.
                          For instance, if our Services) is temporarily
                          suspended for maintenance, we might send you an email.
                          Generally, you may not opt-out of communications which
                          are not promotional in nature. If you do not wish to
                          receive them, you may delete your account.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Information Security
                        </p>
                      </div>
                    </div>
                    <ul className="pt-[10px] pl-[35px]">
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <div>
                            <p>
                              Our Websites and Service(s) have industry-standard
                              security measures in place to protect against the
                              loss, misuse, and alteration of the information
                              under our control. When you provide us with
                              sensitive information (such as credit card
                              information or login credentials), we will encrypt
                              that information via Secure Socket Layer (SSL).
                            </p>
                            <p>
                              Although we will do our best to protect your
                              personal data, we cannot guarantee the security of
                              your data transmitted to our Websites or via the
                              Service(s) and any transmission is at your own
                              risk. Once we receive your personal information,
                              we will use strict procedures and security
                              features to try to prevent unauthorized access.
                            </p>
                            <p>
                              We adopt appropriate data collection, storage, and
                              processing practices and security measures to
                              protect against unauthorized access, alteration,
                              disclosure or destruction of your personal
                              information, username, password, transaction
                              information and data stored on our Site.
                            </p>
                          </div>
                        </div>
                        <ul className="pt-[8px] pl-[35px]">
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faArrowRight}
                              />
                              <p>
                                Our website is scanned on a regular basis for
                                security holes and known vulnerabilities in
                                order to make your visit to our site as safe as
                                possible.
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faArrowRight}
                              />
                              <p>We use regular Malware Scanning.</p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faArrowRight}
                              />
                              <p>
                                Your personal information is contained behind
                                secured networks and is only accessible by a
                                limited number of persons who have special
                                access rights to such systems, and are required
                                to keep the information confidential. In
                                addition, all sensitive/credit information you
                                supply is encrypted via Secure Socket Layer
                                (SSL) technology.
                              </p>
                            </div>
                          </li>
                          <li className="pb-[8px]">
                            <div className="inline-flex">
                              <FontAwesomeIcon
                                className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                                icon={faArrowRight}
                              />
                              <p>
                                All payment transactions are processed through
                                secure gateway providers and are not stored or
                                processed on our servers
                              </p>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <div>
                            <p>
                              <b>Testimonials</b>
                            </p>
                            <p>
                              {" "}
                              We post customer testimonials/comments/reviews on
                              our Websites which may contain personal
                              information. Prior to posting the testimonial, we
                              obtain the customer's consent to post their name
                              along with their testimonials. If you want your
                              testimonial removed, please{" "}
                              <a className="text-[#5b6efd]" href="/privacy">
                                reach out to us
                              </a>
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <div>
                            <p>
                              <b>Children's Personal Information</b>
                            </p>
                            <p>
                              Miles Education does not knowingly collect any
                              personal information from children under the age
                              of 16. If you are under the age of 16, please do
                              not submit any personal information through our
                              Websites or Service(s). We encourage parents and
                              legal guardians to monitor their children’s
                              Internet usage and to help enforce this Policy by
                              instructing their children never to provide
                              personal information through our Service(s) or
                              Websites without their permission. If you have
                              reason to believe that a child under the age of 16
                              has provided personal information to us through
                              our Websites or Service(s), please contact us and
                              we will endeavor to delete that information and
                              terminate the child's account from our databases.
                            </p>
                          </div>
                        </div>
                      </li>
                      <li className="pb-[8px]">
                        <div className="inline-flex">
                          <FontAwesomeIcon
                            className="md:text-[16px] text-xs text-[#0043b8] md:pr-[5px] md:pt-[5px] pr-[5px] pt-[2px] font-bold"
                            icon={faAnglesRight}
                          />
                          <div>
                            <p>
                              <b>Amendments</b>
                            </p>
                            <p>
                              {" "}
                              Miles Education has the discretion to update this
                              privacy policy at any time. When we do, we will
                              post a notification on the main page of our Site,
                              revise the updated date at the bottom of this page
                              and send you an email. We encourage Users to
                              frequently check this page for any changes to stay
                              informed about how we are helping to protect the
                              personal information we collect. You acknowledge
                              and agree that it is your responsibility to review
                              this privacy policy periodically and become aware
                              of modifications. Your continued use of this
                              website or the Service(s) following the posting of
                              any amendment, modification, or change to this
                              Policy shall constitute your acceptance of the
                              amendments to this Policy. You can choose to
                              discontinue the use of the Websites or Service(s),
                              if you do not accept the terms of this Policy, or
                              any modified version of this Policy.
                            </p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                    <div className="inline-flex">
                      <FontAwesomeIcon
                        className="md:pr-[10px] md:pt-[6px] pr-2 pt-[6px] text-[12px] text-[#0043b8]"
                        icon={faCircle}
                      />
                      <div>
                        <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                          Contacting Miles Education
                        </p>
                        <p>
                          If you have any questions about this privacy policy or
                          your dealings with the Miles Education, you can reach
                          out to us using the Miles Education
                          <a className="text-[#5b6efd] pl-[3px]" href="/">
                            Help and Support page.
                          </a>{" "}
                          Or you can also reach out to us through email at
                          <a
                            className="text-[#5b6efd] pl-[3px]"
                            href="mailto: info@mileseducation.com"
                          >
                            info@mileseducation.com{" "}
                          </a>
                          or postal mail at:
                        </p>
                        <p>
                          <b>Level -1, Jayabheri Silicon Towers,</b>
                        </p>
                        <p>
                          <b>Hitec City Road, Hyderabad-500084</b>
                        </p>
                        <p>
                          <b>India</b>
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <GlobalFooter />
      </div>
    </>
  );
};

export default MobilePage;
